var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitorHeartAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.5H22V4C22 2.89543 21.1046 2 20 2H4C2.89543 2 2 2.89543 2 4V15.5ZM12.8527 11.4831C12.387 12.3854 11.0968 12.3854 10.6312 11.4831L9.22051 8.75H4C3.58579 8.75 3.25 8.41421 3.25 8C3.25 7.58579 3.58579 7.25 4 7.25H9.37281C9.84051 7.25 10.2691 7.51109 10.4836 7.9267L11.7419 10.3647L13.8126 6.35282C14.2318 5.54069 15.3523 5.43825 15.9118 6.16091L16.7549 7.25H20C20.4142 7.25 20.75 7.58579 20.75 8C20.75 8.41421 20.4142 8.75 20 8.75H16.6323C16.2456 8.75 15.8807 8.571 15.6439 8.26522L14.9657 7.38919L12.8527 11.4831Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V17H22ZM19 20C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18C18.4477 18 18 18.4477 18 19C18 19.5523 18.4477 20 19 20Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorHeartAlt);
export default __webpack_public_path__ + "static/media/monitor-heart-alt.e24f69e8fc271e5f023e9c9bb969f2d5.svg";
export { ForwardRef as ReactComponent };